import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";

import FollowFacebook from "../components/FollowFacebook";
import FollowInstagram from "../components/FollowInstagram";

function TravelInsights() {
  const navigate = useNavigate();

  return (
    <div
      className="App travel-screen travelinsights-page"
      style={{
        backgroundImage: "url('/images/worldmap.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Header />

      <div className="intro-container">
        <div className="message-box">
          <h2>The Finding Spot For Travelers</h2>

          <p className="travel-message">
            Welcome to The Finding Spot — a space created by an enthusiastic
            explorer who loves uncovering new places and sharing the stories
            behind them. Every destination has its own unique charm, and some
            experiences simply can't be captured by photos or videos alone.
          </p>

          <p className="travel-message">
            If you love to travel, I invite you to explore this page. Here,
            you’ll find personal travel stories, practical tips, and honest
            reflections for fellow adventurers.
          </p>

          <p className="travel-message">
            You may notice some green buttons — these mark destinations I
            haven’t visited yet or pages still in progress. Blue buttons link to
            places already explored.
          </p>

          <p className="travel-message">
            This site grows with every adventure.
          </p>
        </div>

        <div className="button-row">
          <Link className="main-button" to="/">Go Back</Link>

          {/* ⭐ NEW: Navigate to the universal map page */}
          <button
            className="main-button"
            onClick={() => navigate("/map/usa")}
          >
            Start the journey
          </button>
        </div>

        {/* ⭐ SOCIAL ICONS UNDER THE 2 BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "15px",
          }}
        >
          <FollowFacebook />
          <FollowInstagram />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default TravelInsights;
